import GDPRSection from "./Feeds/GDPRSection";
import CustomCodeSection from "./Feeds/CustomCodeSection";
import CachingSection from "./Feeds/CachingSection";

const FeedsSettings = () => {
  return (
    <>
      <CachingSection />
      <GDPRSection />
      <CustomCodeSection />
    </>
  );
};

export default FeedsSettings;
